import MessageBus from '@mtt/postal-kit';

export default function createForwardActionsMiddleware({
  outgoingTopic,
  incomingTopic,
  match,
}) {
  return ({ dispatch }) => {
    MessageBus.subscribe({
      topic: incomingTopic,
      callback: ({ action }) => {
        dispatch(action);
      },
    });

    return next => action => {
      const result = next(action);
      if (match(action)) {
        MessageBus.publish({ topic: outgoingTopic, data: action });
      }
      return result;
    };
  };
}
